import React from "react";
import { useNavigate } from "react-router-dom";
import "./LegalPages.css";
import { useLang, LangToggle } from "../components/LangToggle";

export default function Legal() {
  const navigate = useNavigate();
  const [lang] = useLang();

  return (
    <div className="legalPage">
      <button className="legalPage__back" onClick={() => navigate("/")}>
        {lang === "fr" ? "retour" : "back"}
      </button>
      <LangToggle />

      <div className="legalPage__content">
        {lang === "fr" ? (
          <>
            <h1 className="legalPage__title">mentions légales</h1>
            <p className="legalPage__muted">Dernière mise à jour : 16/05/2026</p>

            <h2>Éditeur</h2>
            <p>
              Nom commercial : Ghetto Symphony
              <br />
              Forme juridique : Entrepreneur individuel (micro-entreprise)
              <br />
              Exploitant : Hugo Armand Mbom
              <br />
              Directeur de la publication : Hugo Armand Mbom
              <br />
              SIRET : 103 137 964 00013
              <br />
              SIREN : 103 137 964
              <br />
              Code APE : 4791B – Vente à distance sur catalogue spécialisé
              <br />
              Immatriculation : 10/04/2026
              <br />
              Adresse : 35 Passage Clemenceau, 34000 Montpellier, France
              <br />
              Email : hugombom2005@gmail.com
              <br />
              Téléphone : +33 6 23 66 21 78
            </p>

            <h2>TVA</h2>
            <p>TVA non applicable – article 293 B du CGI.</p>

            <h2>Hébergement</h2>
            <p>
              Ce site est hébergé par Vercel Inc., 340 Pine Street, Suite 701,
              San Francisco, CA 94104, États-Unis.
              <br />
              Site web : vercel.com
            </p>

            <h2>E-commerce &amp; paiements</h2>
            <p>
              Le checkout et le traitement des paiements sont gérés via Shopify Inc.
              et ses partenaires de paiement. Ghetto Symphony ne conserve pas les
              coordonnées bancaires complètes.
            </p>

            <h2>Propriété intellectuelle</h2>
            <p>
              L'ensemble du contenu de ce site — textes, images, vidéos, logos et
              créations — est la propriété exclusive de Hugo Armand Mbom exerçant
              sous le nom commercial Ghetto Symphony, et est protégé par le droit de
              la propriété intellectuelle. Toute reproduction, distribution ou
              utilisation sans autorisation écrite préalable est strictement
              interdite.
            </p>

            <h2>Contact</h2>
            <p>Pour toute demande : hugombom2005@gmail.com</p>
          </>
        ) : (
          <>
            <h1 className="legalPage__title">legal notice</h1>
            <p className="legalPage__muted">Last update: 16/05/2026</p>

            <h2>Publisher</h2>
            <p>
              Trade name: Ghetto Symphony
              <br />
              Legal form: Entrepreneur individuel (micro-entreprise)
              <br />
              Owner: Hugo Armand Mbom
              <br />
              Publication director: Hugo Armand Mbom
              <br />
              SIRET: 103 137 964 00013
              <br />
              SIREN: 103 137 964
              <br />
              APE code: 4791B – Vente à distance sur catalogue spécialisé
              <br />
              Registered: 10/04/2026
              <br />
              Address: 35 Passage Clemenceau, 34000 Montpellier, France
              <br />
              Email: hugombom2005@gmail.com
              <br />
              Phone: +33 6 23 66 21 78
            </p>

            <h2>VAT</h2>
            <p>TVA non applicable – article 293 B du CGI.</p>

            <h2>Hosting</h2>
            <p>
              This website is hosted by Vercel Inc., 340 Pine Street, Suite 701,
              San Francisco, CA 94104, United States.
              <br />
              Website: vercel.com
            </p>

            <h2>E-commerce &amp; payments</h2>
            <p>
              Checkout and payment processing are handled via Shopify Inc. and its
              payment partners. Ghetto Symphony does not store full payment card
              details.
            </p>

            <h2>Intellectual property</h2>
            <p>
              All content on this website — including text, images, videos, logos,
              and designs — is the exclusive property of Hugo Armand Mbom operating
              under the trade name Ghetto Symphony, and is protected by applicable
              intellectual property law. Any reproduction, distribution, or use
              without prior written consent is strictly prohibited.
            </p>

            <h2>Contact</h2>
            <p>For any request: hugombom2005@gmail.com</p>
          </>
        )}
      </div>
    </div>
  );
}
